import * as STD from '@emersya/mpa-std-lib';
import CM       from '@emersya/mpa-components-manager-lib';
export interface IFramePopupComponentConfiguration extends IFrameComponentConfiguration {
	URL : string | null;
};
export class FramePopupComponent<
	TConfiguration extends IFramePopupComponentConfiguration
> extends FrameComponent<
	HTMLHtmlElement | null,
	FramePopupComponent<TConfiguration>,
	TConfiguration
> {
	component_DOM : HTMLHtmlElement | null = null;
	popupContentDOM = document.createElement('div');
	override async component_onActivationChange(event : STD.events.Event<any, CM.Component<any, any>>) {
		await super.component_onActivationChange(event);
		if (event.subType === 'enabled') {
			if (this.component_configuration.URL) {
				await this.load();
			}
		} else {
			if (this.window) {
				this.window.close();
				this.window = null;
			}
		}
	};
	// close() {
	// 	if (!this.window) {
	// 		this.component_throwUserError('Cannot close an unloaded frame!');
	// 	}
	// 	if (this.loadingListener) {
	// 		throw 'NOT IMPLEMENTED CASE!';
	// 	}
	// 	this.window.removeEventListener('click', this.onLoaded.bind(this));
	// 	this.window = null;
	// };
	async load() {
		if (this.component_isDisabled) {
			this.component_throwUserError('Cannot call load if component is disabled!');
		}
		if (this.loadingListener) {
			await this.cancelLoading();
		}
		if (!this.URL) {
			this.component_throwUserError('URL need to be defined before calling load!');
		}
		await this.dispatchEvent('loading', {
			subType : 'beforeLoad',
			details : {}
		});
		this.window = window.open(this.URL, this.component_getPath(), 'toolbar=0,location=0,menubar=0');
		if (!this.window) {
			this.component_throwLibraryError('??');
		}
		this.window.document.open();
		const promise : Promise<void> = new Promise((resolve, reject) => {
			this.loadingListener = [ resolve, reject ];
		});
		this.window.addEventListener('load', this.onLoaded.bind(this));
		this.window.addEventListener('beforeunload', this.onBeforeUnload.bind(this));
		this.window.document.close();
		this.window.document.body.appendChild(this.popupContentDOM);
		STD.translationsManager.update(this.window.document);
		await promise;
	};
	async cancelLoading() {
		if (!this.loadingListener || !this.window) {
			this.component_throwUserError('Nothing to cancel!');
		}
		const loadingListener = this.loadingListener;
		this.loadingListener = [ () => {}, () => {} ];
		this.window.close();
		this.window = null;
		this.loadingListener = null;
		await loadingListener[1]('cancelled');
	};
	override async component_appendOuterChild(
		component : CM.Component<any, any>,
		_slot      : string | HTMLElement
	) {
		//Call Component.appendOuterChild but not DOMComponent.appendOuterChild
		//because its implementation is not compatible
		await CM.Component.prototype.component_appendOuterChild.call(this, component, _slot);
		if (!(component instanceof CM.DOMComponent)) {
			return;
		}
		if (_slot instanceof HTMLElement) {
			_slot.appendChild(component.component_DOM);
		} else if (component.component_parentSlot) {
			if (!(component.component_parentSlot instanceof CM.DOMComponent)) {
				throw new Error('Not implemented');
			}
			component.component_parentSlot.component_DOM.appendChild(component.component_DOM);
		} else {
			this.popupContentDOM.appendChild(component.component_DOM);
		}
	};
	constructor(
		descriptor    : ConstructorParameters<typeof CM.Component>[0],
		configuration : TConfiguration
	) {
		super(descriptor, configuration);
	};
	private loadingListener : ([
		() => (void | Promise<void>),
		(error : any) => (Promise<void> | void)
	]) | null = null;
	private async onBeforeUnload() {
		await this.dispatchEvent('loading', {
			subType : 'beforeUnload',
			details : {}
		});
		if (this.loadingListener) {
			const loadingListener = this.loadingListener;
			this.loadingListener = null;
			await loadingListener[1]('closed');
		}
		this.window = null;
		await this.dispatchEvent('loading', {
			subType : 'unload',
			details : {}
		});
	};
	private async onLoaded() {
		if (!this.window) {
			this.component_throwLibraryError('');
		}
		this.component_DOM = <HTMLHtmlElement>this.window.document.documentElement;
		if (!this.loadingListener) {
			this.component_throwLibraryError('');
		}
		const loadingListener = this.loadingListener;
		this.loadingListener = null;
		await loadingListener[0]();
		await this.dispatchEvent('loading', {
			subType : 'load',
			details : {}
		});
	};
};
export namespace NS {
	export const Component = FramePopupComponent;
	export type Component<TConfiguration extends IFramePopupComponentConfiguration>  = FramePopupComponent<TConfiguration>;
	export type Configuration = IFramePopupComponentConfiguration;
};
import { FrameComponent, IFrameComponentConfiguration } from '../Frame/Frame';
CM.declare({
	id       : 'frame-popup',
	type     : FramePopupComponent
});
